import { ArrowRightIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { ContentBriefDownloadFormat } from './content-brief.interface'
import { ContentBriefCopyButton } from './content-brief-copy-button.atom'
import { ContentBriefDownloadButton } from './content-brief-download-button.atom'

export interface ContentBriefHeaderActionsProps {
  commentCount: number
  isHtml?: boolean
  isReadOnly?: boolean
  onDownload: (format: ContentBriefDownloadFormat) => void
  onCopy: () => void
  onProceed: () => void
  className?: string
}

const MARKDOWN_DOWNLOAD_FORMAT_LIST: ContentBriefDownloadFormat[] = ['md', 'txt']
const HTML_DOWNLOAD_FORMAT_LIST: ContentBriefDownloadFormat[] = ['pdf', 'html']

export const ContentBriefHeaderActions: React.FC<ContentBriefHeaderActionsProps> = ({
  commentCount,
  isHtml = false,
  isReadOnly = false,
  onDownload,
  onCopy,
  onProceed,
  className,
}): ReactNode => (
  <div
    className={cn(
      'content-brief-header-actions flex items-center gap-2 border-b bg-background px-4 py-2',
      className
    )}
  >
    <ContentBriefDownloadButton
      formatList={isHtml ? HTML_DOWNLOAD_FORMAT_LIST : MARKDOWN_DOWNLOAD_FORMAT_LIST}
      onDownload={onDownload}
    />
    <ContentBriefCopyButton onCopy={onCopy} />

    <div className="flex-1" />

    {!isReadOnly && (
      <Button size="sm" onClick={onProceed} className="content-brief-proceed-button cursor-pointer">
        Proceed
        {commentCount > 0 && (
          <span className="ml-1 rounded-full bg-primary-foreground/20 px-1.5 text-xs">
            {commentCount}
          </span>
        )}
        <ArrowRightIcon className="size-4" />
      </Button>
    )}
  </div>
)
